@if (state(); as vm) {
  <h2 class="heading-xl" i18n>Invite friends</h2>
  <p class="body-copy-sm violet-darkest" i18n>
    Enter the email addresses of the friends you want to invite to join your
    trip.
  </p>
  <form class="form" (submit)="sendInvite.next()" [formGroup]="form">
    <div
      #errorSummary
      id="errorSummary"
      role="alert"
      tabindex="-1"
      class="form-errors">
      @if (vm.error) {
        <div class="form-error">
          <div class="icon icon-alert-circle"></div>
          <div>{{ vm.error }}</div>
        </div>
      }
      @if (form.hasError('required')) {
        <div class="form-error">
          <div class="icon icon-alert-circle"></div>
          <div i18n>You have to specify at least one contact or email.</div>
        </div>
      }
    </div>
    @if (vm.isLoading) {
      <div class="empty-content">
        <div class="loading-spinner"></div>
        <p i18n>Sending invites...</p>
      </div>
    } @else {
      <at-form-field label="Email" i18n-label>
        <input #emailInput type="email" formControlName="email" (input)="contactsFilter.set(emailInput.value)" />
        <p class="form-error" *atControlError="'required'" i18n>
          Email is required
        </p>
        <p class="form-error" *atControlError="'email'" i18n>Email is invalid</p>
      </at-form-field>
      @let contacts = contactsFiltered();
      @if (userHasContacts()) {
        <h3 class="heading-md" i18n>Your contacts</h3>
        @if (contacts.length > 0) {
          <ul cdkListbox cdkListboxMultiple class="at-listbox contacts" formControlName="emails">
            @for (contact of contacts; track contact.userId) {
              <li
                class="at-listbox-item"
                [cdkOption]="contact.email">
                <at-display-name showAvatar [user]="contact"></at-display-name>
              </li>
            }
          </ul>
        } @else {
          <p class="empty-content" i18n>
            No contacts match the search criteria.
          </p>
        }
      }
    }
    <div class="form-actions">
      <button type="submit" class="button primary" i18n>Send invite</button>
      <button
        type="button"
        [disabled]="vm.isLoading"
        class="button tertiary"
        (click)="closeDialog()"
        i18n>
        Cancel
      </button>
    </div>
  </form>
}